/**
 * Phase 8.1 — email masking helper.
 *
 * Rules:
 *   * `alice@example.com`       → `a***e@example.com`
 *   * `ab@example.com`          → `a***b@example.com`
 *   * `a@example.com`           → `a***@example.com`
 *   * `""` or invalid input     → `""`
 *   * Unicode local parts       → uses first/last codepoint safely.
 *
 * Matches the backend helper (`backend/email_verification.py::mask_email`)
 * byte-for-byte for ASCII inputs. The frontend still displays the value
 * `email_masked` returned by `/api/auth/verification-status` in preference
 * to the client-side derivation, but this helper exists so tests and
 * initial paint before the API response also mask consistently.
 */
export function maskEmail(email) {
  if (!email || typeof email !== "string") return "";
  const at = email.indexOf("@");
  if (at < 0) return email;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  if (!local) return `***@${domain}`;
  // Use Array.from so surrogate pairs are counted as one character.
  const chars = Array.from(local);
  if (chars.length === 1) return `${chars[0]}***@${domain}`;
  return `${chars[0]}***${chars[chars.length - 1]}@${domain}`;
}

export default maskEmail;
